import { Directive, ViewContainerRef } from '@angular/core'

@Directive({
  selector: '[appEntityInformationViewComponent]',
})
export class EntityInformationViewComponentDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
